<div fxLayout="column" fxLayoutGap="8px">
  <span class="control-title"
    >{{ label }}
    <span
      *ngIf="isInvalid"
      class="material-symbols-outlined span-icon"
      [matTooltip]="toolTip"
      [ngClass]="{
        'span-icon-red': isInvalid
      }">
      info
    </span>
  </span>
  <div class="bottom-buttons" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="8px">
    <button
      mat-button
      type="button"
      *ngFor="let btn of buttons"
      class="small-button-light-gray"
      [ngClass]="{
        'light-gray-button-selected': btn.isActive
      }"
      (click)="setValue(btn)">
      {{ btn.value }}
    </button>
  </div>
</div>
